import { Order } from '../../../../../core';
import { inStorePickingDetail } from '../../../data-table/data-table-config';

const iconsOfActionsList = inStorePickingDetail.iconsOfActions.filter(item => !item.icon.includes('printer'));

export const inStorePicking = {
  searchText: 'Buscar orden',
  expandable: true,
  expandableType: 'ProductCard',
  checkbox: false,
  detailQuantity: true,
  actionIcons: iconsOfActionsList,
  items: [
    {
      title: 'Empresa',
      name: 'companyCode',
      class: 'col-12',
      value: (element: Order) => element.companyCode
    },
    {
      title: 'N° de Pedido',
      name: 'orderNumber',
      class: 'col-12',
      icon: 'photo',
      value: (element: Order) => element.orderNumber
    },
    {
      title: 'Cliente',
      name: 'customer',
      class: 'col-8',
      value: (element: Order) => element.customer
    },
    {
      title: 'N° de doc.',
      name: 'customerDocumentNumber',
      class: 'col-4',
      value: (element: Order) => element.customerDocumentNumber
    },
    {
      title: 'Receptor',
      name: 'receptor',
      class: 'col-8',
      value: (element: Order) => element.receptor
    },
    {
      title: 'N° de doc.',
      name: 'receptorDocumentNumber',
      class: 'col-4',
      value: (element: Order) => element.receptorDocumentNumber
    },
    {
      title: 'Fecha de retiro',
      name: 'retireDate',
      onFooter: true,
      value: (element: Order) => element.retireDate
    }
  ]
};
